import React from 'react';
import Config from '../../../config/Config'
import NameField from './nameField';
import PinField from './pinField';
import ResendPin from '../sharedComponents/resendPin';

const LoginForm = ({
    headerText,
    hidePin,
    nameInfoText,
}) => (

    <div>
        <div className="login-theader">
            <img src={Config.ASSETSPATH + 'img/STEP_logo.png'} alt="STEPlogo" />
        </div>

        <div className="clogin-name-field sign-in-text">{headerText}</div>
        <div className="login-formbox">
            <div className="form-group">
                <NameField />
                <span><i className="infoText">{nameInfoText}</i> </span>
                <div className={hidePin ? 'hideElement' : ''}>
                    <PinField />
                </div>
                <ResendPin resendText="Forgot Password? Click here!" />
            </div>
        </div>
    </div>
)

export default LoginForm;